export default ['supervised', 'graduated', 'independent'];
